
import SearchConstants from './SearchConstants';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import NpvrUploader from '../../AAF/Npvr/NpvrUploader';
import { setDataSearch } from '../../actions/searcher';
import store from '../../store';
import ModalEpgUtils from '../../components/Epg/ModalEpgUtils';
import Utils from '../../utils/Utils';
import { Dates } from "src/packages/dates/lib/dates.js";
import EpgPersistence from 'src/AAF/Nepg/EpgPersistence';
import {getIdsRibbonsUpAndDown} from "../../components/RibbonGridNew/utis";
import Translator from "../../requests/apa/Translator";

const parseResponse = (response) =>{
    if(!response) return [];
    const result = [];
    let {groups = [], contenidos = [], talentos: {talents: {talent = []} = {}, external_talents: {gracenote = []} = {}} = {}} = response;

    //ADJUNTANDO CONTENIDOS
    contenidos = groups.length > 0 ? groups : contenidos;
    if(contenidos && Array.isArray(contenidos)){
        for(const c in contenidos){
            const item = contenidos[c];

            // SI ES UN EVENTO SE HACE MATCH CON GRABACIONES
            if(item && item.content_type && item.content_type === SearchConstants.EVENT){

                const { channel_group: { common: { id:group_id = null } = {} } = {} } = item;
                if(group_id){
                    item.group_id = group_id;
                }
                if(item.unix_begin){
                    item.date_begin = item.unix_begin;
                }
                if(item.unix_end){
                    item.date_end = item.unix_end;
                }
                if (NpvrUtil.recordingIconEnable().enable) {
                    if(item.id){
                        if(NpvrUploader.isEventRecording(item.id)){
                            // Es una grabación
                            item.content_type = SearchConstants.RECORDING;
                        }
                    }
                }
            }
        }

        result.push(...contenidos);
    }
    //SI EXISTEN TALENTOS Y TALENTOS EXTERNOS
    if(gracenote && Array.isArray(gracenote)){
        const externalTalents = parseGracenote(gracenote);
        result.push(...externalTalents);
    }
    if(talent && Array.isArray(talent)){
        const talensNormal = parseTalents(talent);
        result.push(...talensNormal);
    }
    for(const i in result){
        const tmp = result[i];
        if (tmp && tmp.image_small) {
            try {
              new Image().src = tmp.image_small;
            } catch (error) {}
        }
        if (tmp && tmp.image) {
            try {
                new Image().src = tmp.image;
              } catch (error) {}
        }
        if (tmp && tmp.ext_eventimage_name) {
            try {
                new Image().src = tmp.ext_eventimage_name;
              } catch (error) {}
        }
    }

    return result;
}

const parseTalents = (talents) =>{
    let result = [];
    if(talents && Array.isArray(talents)){
        result = talents.map((talent) =>{
            return {
                id: talent.id || null,
                image: talent.image || null,
                internal_ids: talent.internal_ids || [],
                first_name: talent.name || '',
                name:  talent.name || '',
                last_name: '',
                surname: '',
                fullname: `${talent.name}`,
                content_type:SearchConstants.TALENT,
                typeTalent: SearchConstants.TALENT_TYPE_NORMAL,
                provider_id: 2,
                roles: talent.search_roles || []
            }
        })
    }
    return result;

}


const parseGracenote = (gracenote) =>{
    let result = [];
    if(gracenote && Array.isArray(gracenote)){
        result = gracenote.map(talent => {
            return {
                id: talent.id || null,
                image: talent.image || null,
                internal_ids: talent.internal_ids,
                first_name: talent.first_name || '',
                name:  talent.first_name || '',
                last_name: talent.last_name || '',
                surname:talent.last_name || '',
                fullname: `${talent.first_name} ${talent.last_name}`,
                content_type:SearchConstants.TALENT,
                typeTalent: SearchConstants.TALENT_TYPE_EXTERNAL,
                provider_id: 3,
                roles: talent.search_roles || []
            }
        })
    }
    return result;
}

const getWordsStorage = () => {
  const { wordsSearch = "" } = store.getState().searcher;
  const auxWordsSearch = wordsSearch && wordsSearch !== "" ? wordsSearch : null;
  return auxWordsSearch;
}

const updateDataStoreSearcher = (data) => {
  const nowDataStore = store.getState().searcher;
  store.dispatch(setDataSearch({...nowDataStore, ...data}))
}

const updateDataStoreFlowFuture = (data) => {
  store.dispatch(setDataSearch({flowFuture: data}))
}

const clearDataStorSearch = () => {
    store.dispatch(setDataSearch({ flowFuture: null, listRanking: null }))
}

const showModalOptions = (item) =>{
  const {channel_group = {}, id:groupId = null} = item;
  item.group_id = channel_group && channel_group.common ? channel_group.common.id : groupId;
  ModalEpgUtils.blueHandler({ data: item, from: SearchConstants.FROM_SEARCH_COMPONENT_AAF});
}

const flowFutureSearcherShowOptions = (statusPlayer) => {
  if(statusPlayer && statusPlayer === 'player_starts') {
    const {flowFuture:{ isFuture = false, itemClick = {}} = {}} = store.getState().searcher
    isFuture && showModalOptions(itemClick)
  }
}

export const cutString = (title, size = 25) => {
  const cutTitle = Utils.cutPlayerString(title, size);
  return cutTitle;
};

//Logic for filter channels without timeshift
const haveTimeShiftContentTypeL = (id) => {
  const linealChannels = store.getState().linealChannels;
  const getValueTimeshift = linealChannels.filter((channel) => channel.id === id );
  return getValueTimeshift.length > 0 ? getValueTimeshift[0].timeshift : 0;
};

const changeUnixToMilliseconds = (unix) => {
  return Utils.convertUnixOrFormattedDateToDatesObject(unix)._d.getTime()
}

const getValueTimeshiftEventOrChannel = (content) => {
  const timeShiftEvent = content.channel_group && content.channel_group.common && content.channel_group.common.timeshift
  ? content.channel_group.common.timeshift
  : 0;
  const timeShiftChannel = content.actual_event ? haveTimeShiftContentTypeL(content.id) : 0;
  return content.content_type === SearchConstants.CHANNEL ? timeShiftChannel : timeShiftEvent;

}

const getBeginDate = (content) => {
  return content.actual_event
    ? changeUnixToMilliseconds(content.actual_event.unix_begin)
    : changeUnixToMilliseconds(content.unix_begin);
};

const getEndDate = (content) => {
  return content.actual_event
    ? changeUnixToMilliseconds(content.actual_event.unix_end)
    : changeUnixToMilliseconds(content.unix_end);
};

const isLiveToFilter = (beginDate, endDate, dateNow) => {
  return beginDate <= dateNow && dateNow <= endDate;
};

const isCatchupWithTimeshiftToFilter = (
  beginDate,
  endDate,
  dateNow,
  valueTimeshift
) => {
  const passTime = SearchConstants.PASSTIME * 3600000;
  const validateCatchup = dateNow - beginDate <= passTime;
  return (beginDate <= dateNow && dateNow >= endDate) && valueTimeshift > 0 && validateCatchup;
};

const isFutureToFilter = (beginDate, endDate, dateNow) => {
  const futureTime = SearchConstants.FUTRETIME * 3600000;
  const validateFuturo = beginDate - dateNow <= futureTime;
  return (beginDate >= dateNow && dateNow <= endDate) && validateFuturo;
};

const filterChannelsWithOutTimeshift = (content) => {
  const dateNow = Utils.now(true).utcOffset(EpgPersistence.needsOffset(), false)._d.getTime();

  const valueTimeshift = getValueTimeshiftEventOrChannel(content);
  const beginDate = getBeginDate(content);
  const endDate = getEndDate(content);
  const isLive = isLiveToFilter(beginDate, endDate, dateNow);
  const isCatchupWithTimeshift = isCatchupWithTimeshiftToFilter(
    beginDate,
    endDate,
    dateNow,
    valueTimeshift
  );
  const isFuture = isFutureToFilter(beginDate, endDate, dateNow);

  return isLive || isCatchupWithTimeshift || isFuture;
}

const deleteRibbonSuggestEmpty = (ribbons) => {
  const suggest = ribbons.suggest;
  const sizeSuggest = suggest.suggest ? suggest.suggest.length : 0;

  if (sizeSuggest === 0) delete ribbons.suggest;

  return ribbons;

}

const createObjectsWithIdsUpDown = (_prediction) => {
  const reviewRibbons = deleteRibbonSuggestEmpty(_prediction)
  const keys = Object.keys(reviewRibbons);

  const ribbonsToGetUpDownIds = keys.map((key) => {
    const ribbon = reviewRibbons[key];
    return {
      ...ribbon,
      id: 'buscador',
      title: Translator.get(ribbon.keyApa, ""),
      type: ribbon.typeCarousel
    }
  });

  return getIdsRibbonsUpAndDown(ribbonsToGetUpDownIds, true);
}

const UtilsSearch = {
    parseResponse,
    updateDataStoreFlowFuture,
    showModalOptions,
    flowFutureSearcherShowOptions,
    updateDataStoreSearcher,
    getWordsStorage,
    clearDataStorSearch,
    cutString,
    filterChannelsWithOutTimeshift,
    createObjectsWithIdsUpDown
}

export default UtilsSearch;



// WEBPACK FOOTER //
// ./src/containers/Search/UtilsSearch.js